import axios, { AxiosResponse } from "axios";
import { mel_url, kore_url } from "./index";

export interface individualOrderInterface {
  type: "individual";
  delivery: "Ground" | "Given to patient" | "Express";
  issuedBy: string;
  issuedEmail: string;
  organization: string;
  providerEmail: string;
  orders: {
    memberId: string;
    firstName: string;
    lastName: string;
    email?: string;
    dob: string;
    shipping: {
      street: string;
      city: string;
      state: string;
      zip: string;
      country: string;
    };
    hasHub: boolean;
    selectedHub: string;
    btDevices: string[];
    celDevices: string[];
  }[];
}

export interface bulkOrderInterface {
  type: "bulk";
  delivery: "Ground" | "Given to patient" | "Express";
  issuedBy: string;
  issuedEmail: string;
  organization: string;
  providerEmail: string;
  kit: {
    devices: string[];
    qty: string;
    includeGateway: boolean;
  };
  devices: {
    quantities: { [name: string]: string };
    gatewayQty: string;
  };
  shipping: {
    street: string;
    city: string;
    state: string;
    zip: string;
    country: string;
  };
  notes: string;
}
export interface orderInterface {
  _id?: string;
  clientId?: string;
  type?: string;
  organization?: string;
  delivery?: string;
  issuedBy?: string;
  issuedEmail?: string;
  issuedOn?: string;
  shippedOn?: string;
  receivedOn?: string;
  fulfilled?: boolean;
  sender?: object;
  recipient?: object;
  manifest?: {
    totalItems?: number;
  };
}

export default {
  getAll: (token: string, param?: string) => {
    const paginationParameters = () => {
      let paginationQuery = `${param ? `?${param}` : ""}`;
      return paginationQuery;
    };
    const config = {
      method: "GET",
      url: `${kore_url}/api/v4/orders${paginationParameters()}`,
      headers: {
        "Authorization": `Bearer ${token}`,
        "Access-Control-Allow-Origin": "*"
      }
    };
    return axios(config)
      .then((retAll: AxiosResponse) => {
        return retAll.data;
      })
      .catch((err) => {
        throw err;
      });
  },
  getOne: (orderId: string, token: string) => {
    const config = {
      method: "GET",
      url: `${kore_url}/api/v4/orders/${orderId}`,
      headers: {
        "Authorization": `Bearer ${token}`,
        "Access-Control-Allow-Origin": "*"
      }
    };
    return axios(config)
      .then((retOne: AxiosResponse) => {
        return retOne;
      })
      .catch((err) => {
        throw err;
      });
  },
  createIndividual: (order: individualOrderInterface, token: string) => {
    const config = {
      method: "POST",
      url: `${kore_url}/api/v4/orders`,
      data: order,
      headers: {
        "Authorization": `Bearer ${token}`,
        "Access-Control-Allow-Origin": "*"
      }
    };
    return axios(config)
      .then((created: AxiosResponse) => created)
      .catch((err) => { throw err; });
  },
  createBulk: (order: bulkOrderInterface, token: string) => {
    const config = {
      method: "POST",
      url: `${kore_url}/api/v4/orders`,
      data: order,
      headers: {
        "Authorization": `Bearer ${token}`,
        "Access-Control-Allow-Origin": "*"
      }
    };
    return axios(config)
      .then((created: AxiosResponse) => created)
      .catch((err) => {
        throw err;
      });
  },
  update: (updates: object, orderId: string, token: string) => {
    const config = {
      method: "PUT",
      url: `${kore_url}/api/v4/orders/${orderId}`,
      data: updates,
      headers: {
        "Authorization": `Bearer ${token}`,
        "Access-Control-Allow-Origin": "*"
      }
    };
    return axios(config)
      .then((updated: AxiosResponse) => {
        return updated;
      })
      .catch((err) => {
        throw err;
      });
  },
  sendWelcome: (name: string, email: string, type: string, id?: string) => {
    let config = {
      method: "POST",
      url: `${mel_url}/api/provider/welcome`,
      data: { name: name, email: email, type: type },
      headers: {
        "Access-Control-Allow-Origin": "*"
      }
    };
    if (type === "coordinator") {
      config.url = `${mel_url}/api/grant`;
      // @ts-ignore
      config.data = { email: email, userId: id || "", type: type, new: true };
    }
    return axios(config)
      .then((updated: AxiosResponse) => {
        return updated;
      })
      .catch((err) => {
        throw err;
      });
  }
};
